import { render, staticRenderFns } from "./PlanPartnerList.vue?vue&type=template&id=3d025661&scoped=true&"
import script from "./PlanPartnerList.vue?vue&type=script&lang=js&"
export * from "./PlanPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d025661",
  null
  
)

export default component.exports